module.exports = __webpack_public_path__ + "img/toggle-off.96b2f60d.svg";